import gql from 'graphql-tag';

export const CCA_REQUEST_SLACK_NOTIFICATION_MUTATION = gql`
  mutation CcaRequestGenerationJobSlackNotificationMutation($id: ID!) {
    ccaRequestGenerationJobSlackNotification(id: $id) {
      job {
        id
        status
        notifyOnCompletion
      }
    }
  }
`;
